import "../css/app.css"
import "react-datepicker/dist/react-datepicker.css"

import { createRoot } from "react-dom/client"
import { createInertiaApp } from "@inertiajs/react"
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers"
import { Layout } from "./components/layouts/Layout"

const appName = "Website"

function setupPageLayout(module, name) {
    if (!name.startsWith("Auth")) {
        module.default.layout = (page) => <Layout>{page}</Layout>
    }
}

createInertiaApp({
    title: (title) =>
        `${title}${title ? " | " : ""}Live Every Beat | Real-time immersive audio with Bonza Music`,
    resolve: (name) => {
        const page = resolvePageComponent(
            `./pages/${name}.tsx`,
            import.meta.glob("./pages/**/*.tsx")
        )
        page.then((module) => setupPageLayout(module, name))
        return page
    },
    setup({ el, App, props }) {
        const root = createRoot(el)

        root.render(<App {...props} />)
    },
    progress: {
        color: "#4B5563",
    },
})
